module.exports = __webpack_public_path__ + "img/FR25080.5efffa20.png";